import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook";
import StudentDashboardMobile from "./DashboardMobile";
import { DashboardSidebarWithCalendar } from "../../../stories/DashboardSidebarWithCalendar/DashboardSidebarWithCalendar";
import classes from "./Dashboard.module.css";
import { AfterLoginHeader } from "../../../stories/AfterLoginHeader/AfterLoginHeader";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import { Tabs } from "../../../stories/Tabs/Tabs";
import { InputWithSearchIcon } from "../../../stories/InputWithSearchIcon/InputWithSearchIcon";
import { DropDown } from "../../../stories/DropDown/DropDown";
import { CoachTodoLessonCard } from "../../../stories/CoachTodoLessonCard/CoachTodoLessonCard";
import LessonCard from "../../../components/PopUps/Schedule/LessonCard";
import { StudentMyLessonCard } from "../../../stories/StudentMyLessonCard/StudentMyLessonCard";
import { PerformanceEvaluationCard } from "../../../stories/PerformanceEvaluationCard/PerformanceEvaluationCard";
import { ReactSVG } from "react-svg";

import {
  LessonRequestsIconSvg,
  StarIconRed,
  TransactionIconRedSvg,
  Visa,
  VisaSvg,
  coachDemoImg,
} from "../../../constant/imagePath";
import { Button } from "../../../stories/Button/Button";
import CancelBooking from "../../../components/Modals/StudentFlow/Dashboard/CancelBooking/CancelBooking";
import ReportAProblemModal from "../../../components/Modals/StudentFlow/Dashboard/ReportAProblem/ReportAProblem";
import { MyLessonCard } from "../../../stories/MyLessonCard/MyLessonCard";
import { PaginationComponent } from "../../../stories/Pagination/Pagination";
import { useHistory } from "react-router-dom";

// Dummy Data
const transactionData = [
  {
    amount: "75",
    cardNumber: "3456",
    requestType: "1 on 1 Tennis Lesson",
    user: {
      displayName: "John Johnson",
    },
    type: "upcoming",
    lessonTime: "11/12/2022",
  },
  {
    amount: "75",
    cardNumber: "3456",
    requestType: "1 on 1 Tennis Lesson",
    user: {
      displayName: "John Johnson",
    },
    // type:'upcoming',
    lessonTime: "11/12/2022",
  },
  {
    amount: "75",
    cardNumber: "3456",
    requestType: "1 on 1 Tennis Lesson",
    user: {
      displayName: "John Johnson",
    },
    // type:'upcoming',
    lessonTime: "11/12/2022",
  },
];

const myLessonsData = [
  {
    userData: {
      displayName: "Tyler",
      photo: coachDemoImg,
    },
    date: "Aug 27,2021",
    time: "12:30PM-2:30Pm",
    location: "DeWitt Clinton Park, W54thy St, New York, NY",
    type: "pending",
    income: "$64",
    requestType: "1-on-1 Tennis Lesson",
    timeLeft: "6 days",
  },
  {
    userData: {
      displayName: "Tyler",
      photo: coachDemoImg,
    },
    date: "Aug 27,2021",
    time: "12:30PM-2:30Pm",
    location: "DeWitt Clinton Park, W54thy St, New York, NY",
    type: "completed",
    income: "$64",
    requestType: "1-on-1 Tennis Lesson",
    timeLeft: "6 days",
  },
  {
    userData: {
      displayName: "Tyler",
      photo: coachDemoImg,
    },
    date: "Aug 27,2021",
    time: "12:30PM-2:30Pm",
    location: "DeWitt Clinton Park, W54thy St, New York, NY",
    type: "accepted",
    income: "$64",
    requestType: "1-on-1 Tennis Lesson",
    timeLeft: "6 days",
  },
];

function MyLessons({ data }) {
  const [searchValue, setSearchValue] = useState();
  const [filterOptions, setFilterOptions] = useState();
  const [show, setShow] = useState("");
  const history = useHistory();
  return (
    <>
      <Row className={`${[classes.mt24, classes.searchBox].join(" ")}`}>
        <Col md={8}>
          <InputWithSearchIcon state={searchValue} setter={setSearchValue} />
        </Col>
        <Col md={4}>
          <DropDown
            options={[{ label: "All", value: "All" }]}
            state={filterOptions}
            setter={setFilterOptions}
          />
        </Col>
      </Row>

      <div
        className={`${[
          classes.component1Div,
          data?.length == 0 && classes.overflowUnset,
        ].join(" ")}`}
      >
        {data?.length == 0 ? (
          <NoData
            heading={"You haven’t booked a lesson yet"}
            icon={LessonRequestsIconSvg}
          />
        ) : (
          <Row className={`g-0 ${[classes.mt24].join(" ")}`}>
            {data?.map((item) => {
              return (
                <Col md={12}>
                  <MyLessonCard
                    data={item}
                    onClick1={(e) => {
                      if (e == "chat") {
                        history.push("/student-chat");
                      } else if (e == "report") {
                        setShow("report");
                      } else {
                        setShow(e);
                      }
                    }}
                    onClick2={(e) => {
                      if (e == "cancel") {
                        setShow(e);
                      } else {
                        history.push("/lesson-details", { type: item?.type });
                      }
                    }}
                  />
                </Col>
              );
            })}
          </Row>
        )}
      </div>
      <ReportAProblemModal
        show={show == "report" && true}
        setShow={(e) => setShow("")}
      />
      <CancelBooking
        show={show == "cancel " && true}
        setShow={(e) => setShow("")}
      />
    </>
  );
}
function PerformanceEvaluation({ data }) {
  const [searchValue, setSearchValue] = useState();
  const history = useHistory();
  return (
    <>
      <Row className={`${[classes.mt24, classes.searchBox].join(" ")}`}>
        <Col md={12}>
          <InputWithSearchIcon state={searchValue} setter={setSearchValue} />
        </Col>
      </Row>
      <div
        className={` g-2 ${[
          classes.mt24,
          classes.component2Div,
          data?.length == 0 && classes.overflowUnset,
        ].join(" ")}`}
      >
        {data?.length == 0 ? (
          <NoData
            heading={"You have no performance evaluation"}
            icon={StarIconRed}
          />
        ) : (
          <Row style={{ height: "max-content" }}>
            {data?.map((item) => {
              return (
                <Col md={6} className={classes.mb24}>
                  <PerformanceEvaluationCard
                    onClick={() =>
                      history.push("/performance-evaluation", {
                        type: item?.type,
                      })
                    }
                  />
                </Col>
              );
            })}
          </Row>
        )}
      </div>
    </>
  );
}
function TransactionHistory({ data }) {
  const [searchValue, setSearchValue] = useState();

  return (
    <>
      <Row className={` ${[classes.pt24].join(" ")}`}>
        <Col md={12} className={`${[classes.mb32].join(" ")}`}>
          <InputWithSearchIcon state={searchValue} setter={setSearchValue} />
        </Col>
      </Row>

      <div
        className={`${[
          classes.component3Div,
          data?.length == 0 && classes.overflowUnset,
        ].join(" ")}`}
      >
        {data?.length > 0 ? (
          <Row>
            <Col md={5}>
              <p style={{ ...Fonts.h9, color: Colors.neutralShadesOfDimGray }}>
                Date
              </p>
            </Col>
            <Col md={5}>
              <p style={{ ...Fonts.h9, color: Colors.neutralShadesOfDimGray }}>
                Payment method
              </p>
            </Col>
            <Col md={2}>
              <p style={{ ...Fonts.h9, color: Colors.neutralShadesOfDimGray }}>
                Total
              </p>
            </Col>

            <Col md={12}>
              {data?.map((item) => {
                return (
                  <Row className={` ${classes.tr}`}>
                    <Col md={5}>
                      {item?.type == "upcoming" && (
                        <span
                          style={{
                            ...Fonts.h7,
                            lineHeight: "24px",
                            fontFamily: "inter-600",
                            color: Colors.neutralShadesOfPinkSwan,
                          }}
                        >
                          {item?.lessonTime} (upcoming)
                        </span>
                      )}
                      <p
                        style={{
                          ...Fonts.p1,
                          color: Colors.neutralShadesOfNero,
                        }}
                      >
                        {item?.requestType} with {item?.user?.displayName}
                      </p>
                    </Col>
                    <Col md={5}>
                      <div className={classes.iconWithText}>
                        <ReactSVG
                          src={VisaSvg}
                          beforeInjection={(svg) =>
                            svg.classList.add(classes.icon)
                          }
                        />
                        <span
                          style={{
                            ...Fonts.p2,
                            color: Colors.neutralShadesOfNero,
                          }}
                        >
                          &#8226;&#8226;&#8226; &#8226;&#8226;&#8226;
                          &#8226;&#8226;&#8226; {item?.cardNumber}
                        </span>
                      </div>
                    </Col>
                    <Col md={2}>
                      <h5
                        style={{
                          ...Fonts.h5,
                          fontSize: "16px",
                          color:
                            item?.type == "upcoming"
                              ? Colors.neutralShadesOfPinkSwan
                              : Colors.neutralShadesOfNero,
                        }}
                      >
                        ${item?.amount}
                      </h5>
                    </Col>
                  </Row>
                );
              })}
            </Col>
          </Row>
        ) : (
          <NoData
            heading={"You have no transaction history"}
            icon={TransactionIconRedSvg}
          />
        )}
      </div>
    </>
  );
}

function NoData({ heading, icon }) {
  return (
    <div className={classes.noData}>
      <div>
        <ReactSVG
          src={icon}
          beforeInjection={(svg) =>
            svg.classList.add(classes.icon, classes.mb24)
          }
        />
        <h4
          style={{
            ...Fonts.h4,
            fontSize: "26px",
            color: Colors.neutralShadesOfNero,
          }}
          className={classes.mb8}
        >
          {heading}
        </h4>
        <p
          style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
          className={classes.mb24}
        >
          You haven’t booked any lessons yet. But as soon as you do they’ll
          appear here.
        </p>
        <Button
          label={"Look for a Coach"}
          customStyle={{ padding: "12px 32px", width: "max-content" }}
          primary={true}
        />
      </div>
    </div>
  );
}

function StudentDashboardDesktop() {
  const [locations, setLocations] = useState();
  const [tabState, setTabState] = useState({ label: "My lessons" });
  const [pageNo, setPageNo] = useState(1);
  const [data, setData] = useState(myLessonsData);
  const [customClass, setCustomClass] = useState("");

  // For Header
  const onClickSearch = (data) => {
    setCustomClass(data);
  };
  const handleSearch = (data) => {
    console.log(data);
  };

  useEffect(() => {
    if (tabState.label == "My lessons") {
      setData(myLessonsData);
    } else if (tabState.label == "performance evaluation") {
      setData([]);
    } else {
      setData(transactionData);
      // setData([])
    }
  }, [tabState]);

  return (
    <div>
      <Container fluid className={classes.mainContainer}>
        <div
          className={classes.header}
          style={{ borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}` }}
        >
          <AfterLoginHeader
            showSearch
            customStyle={{ background: Colors.white, padding: "20px 24px" }}
            onClickSearch={onClickSearch}
            handleSearch={handleSearch}
          />
        </div>
        <Row className={["g-0", classes.row].join(" ")}>
          <Col md={4} xl={3}>
            <DashboardSidebarWithCalendar
              locations={locations}
              setLocations={setLocations}
              isShowHeader={false}
            />
          </Col>
          <Col md={8} xl={9} className={[classes.p24].join(" ")}>
            {/* Main Content */}
            <Row className={"g-0"}>
              <Col md={12} className={classes.mainContent}>
                <h3
                  className={classes.mt24}
                  style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}
                >
                  My lessons
                </h3>
                <div className={classes.mt24}>
                  <Tabs
                    state={tabState}
                    setState={setTabState}
                    tabsData={[
                      { label: "My lessons", value: 8 },
                      { label: "Performance evaluation", value: 16 },
                      { label: "Transaction history", value: 3 },
                    ]}
                  />
                </div>
              </Col>
              <Col
                md={12}
                className={`${[classes.pl40, classes.pr20].join(" ")}`}
              >
                {tabState?.label == "My lessons" && <MyLessons data={data} />}
                {tabState?.label == "Performance evaluation" && (
                  <PerformanceEvaluation data={data} />
                )}
                {tabState?.label == "Transaction history" && (
                  <TransactionHistory data={data} />
                )}
              </Col>
              {/* Pagination */}
              {data?.length > 0 && (
                <Col md={12}>
                  <PaginationComponent
                    totalPages={Math.ceil(data?.length / 4)}
                    setCurrentPage={setPageNo}
                    currentPage={pageNo}
                  />
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

function StudentDashboard() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <StudentDashboardMobile /> : <StudentDashboardDesktop />;
}

export default StudentDashboard;
